import React, {useContext} from "react";
import {Avatar, Skeleton, Typography} from "@mui/material";
import clsx from "clsx";
import multiavatar from "@multiavatar/multiavatar";
import SVG from "react-inlinesvg";
import BusinessTwoToneIcon from "@mui/icons-material/BusinessTwoTone";
import {AuthContext} from "../../../../App";

const UserDrawer = ({classes, selectMenuItem, stato}) => {
	const authContext = useContext(AuthContext);

	return (
		<aside className={classes.drawer}>
			<div className={classes.drawerHeader}>
				<div>
					<Typography className={classes.drawerTitle}>Aziende</Typography>
					<Typography className={classes.drawerSubtitle}>
						Seleziona il perimetro utenti.
					</Typography>
				</div>
				<BusinessTwoToneIcon/>
			</div>

			<div className={classes.companyList}>
				{authContext.state.loadingGetCompanies && [0, 1, 2].map((item) => (
					<Skeleton key={item} height={62} variant="rounded"/>
				))}

				{!authContext.state.loadingGetCompanies && authContext.state.errorGetCompanies !== "" && (
					<Typography className={classes.emptyState}>
						Errore nel recupero delle aziende.
					</Typography>
				)}

				{!authContext.state.loadingGetCompanies && authContext.state.errorGetCompanies === "" && authContext.state.companies.map((company) => (
					<button
						key={company.id || company.nome}
						type="button"
						className={clsx(classes.companyButton, stato?.nome === company.nome && classes.companyButtonSelected)}
						onClick={() => selectMenuItem(company)}
					>
						<Avatar className={classes.companyAvatar}>
							<SVG src={multiavatar(company.nome || "Atlantis")}/>
						</Avatar>
						<span>
							<Typography className={classes.companyName}>
								{company.nome}
							</Typography>
							<Typography className={classes.companyMeta}>
								{company.id ? `ID ${company.id}` : "Perimetro utenti"}
							</Typography>
						</span>
					</button>
				))}
			</div>
		</aside>
	);
};

export default React.memo(UserDrawer);
